module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyNCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC42MzQwMzMiIHk9IjAuMzM4ODY3IiB3aWR0aD0iMjMuMjkyIiBoZWlnaHQ9IjMuMTAzNzMiIHJ4PSIxLjU1MTg3IiBmaWxsPSIjMzMzMzMzIi8+CjxyZWN0IHg9IjAuNjM0MDMzIiB5PSI4Ljg3NDAyIiB3aWR0aD0iMjMuMjkyIiBoZWlnaHQ9IjMuMTAzNzMiIHJ4PSIxLjU1MTg3IiBmaWxsPSIjMzMzMzMzIi8+CjxyZWN0IHg9IjAuNjM0MDMzIiB5PSIxNy40MDkyIiB3aWR0aD0iMjMuMjkyIiBoZWlnaHQ9IjMuMTAzNzMiIHJ4PSIxLjU1MTg3IiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/hamburger-icon.svg
// module id = Xs4W
// module chunks = 46